import { css } from '../../../styled-system/css';
import { TermsLayout } from '#/components/terms/TermsLayout';
import { TermsCard } from '#/components/terms/TermsCard';
import { useTitle } from '#/utils/useTitle';
import { Clause } from '#/components/terms/Clause';

export function Terms() {
  useTitle('利用規約');
  return (
    <TermsLayout>
      <h1 className={css({ textStyle: 'headding.l', paddingBottom: '{spacing.24}' })}>利用規約　</h1>
      <TermsCard>
        本規約は、当社及び提携法人が提供する各種サービス等をID保有者が連携して利用することができるよう、ZEN
        IDを利用してID保有者情報を提携法人と連携する際の条件等を定めるものです。
        <Clause title="第1条（定義）">
          本規約で使用される用語の定義は以下のとおりとします。
          <ul>
            <li>（1）「当社」とは、株式会社ドワンゴをいいます。</li>
            <li>
              （2）「ZEN ID」とは、対象サービスを利用するために必要となるアカウントIDをいいます。ID保有者は、ZEN
              IDを利用することで、対象サービスに係るウェブサイトにログインすることができます。
            </li>
            <li>（3）「提携法人」とは、本規約に基づきZEN IDを利用しID保有者情報の連携を行う法人をいいます。</li>
            <li>
              （4）「本サービス」とは、ZEN
              IDを利用してID保有者情報を提携法人と連携することにより、当社及び提携法人が提供する各種サービス等をID保有者が連携することを目的としたサービスをいいます。
            </li>
            <li>（5）「本サービス契約」とは、本規約に基づき成立する本サービスに関する契約をいいます。</li>
            <li>
              （6）「ID保有者」とは、本サービスに係るウェブページ上で当社の定める必要な情報を入力するID登録申込をし、本規約に同意した者をいいます。
            </li>
            <li>
              (7) 「対象サービス」とは、当社及び当社の提携法人による、「ZEN
              ID」を利用して受けられるインターネットを利用した教育・学習サービス及び教育・学習サービスを達成するために必要なサービスをいいます。
            </li>
            <li>
              (8) 「対象サービスアカウント連携」とは、当社が提供する本サービスにおいて、ZEN
              IDと当社または提携法人が運営する対象サービスのアカウントを連携させることをいいます。
            </li>
            <li>
              (9)「ID保有者情報」とは、当社の「個人情報保護基本方針」で定義されている個人情報及び同意情報をいいます。
            </li>
          </ul>
        </Clause>
        <Clause title="第2条（ZEN ID保有者）">
          <ul>
            <li>1. ID保有者は、ID登録申込に際して、以下の条件を了承し、遵守するものとします。</li>
            <ul>
              <li>
                （1）本サービスに係るID保有者登録専用ページの入力欄に、ID保有者自身のID登録に必要なデータを真実かつ正確に入力すること。代理による入力・ID登録申込は一切認められません。
              </li>
              <li>
                （2）ID登録申込時にメールアドレスを登録する際は、ID保有者自身の保有するメールアドレスを登録すること。他人のメールアドレスでの登録は認められません。
              </li>
              <li>（3）(1)の登録事項に変更があった場合、ID保有者は速やかに登録内容の変更を行うこと。</li>
              <li>（4）1人のID保有者による複数のIDの登録および保有は認められません。</li>
              <li>（5）18歳未満のID保有者は、保護者の同意を得てID登録申込みを行うこと。</li>
            </ul>
          </ul>
        </Clause>
        <Clause title="第3条（対象サービスアカウント連携）">
          <ul>
            <li>
              1.
              対象サービスは、当社が定める手順に従って、対象サービスのアカウント連携手続きを行うことにより利用できるものとします。連携手続きは、本サービスを利用されるID保有者が行ってください。代理によるお手続きは一切認められません。
            </li>
            <li>
              2.
              連携手続きを行うにあたり、対象サービスに登録されたID保有者情報を当社が取得し、当社の各サービスにおいて表示する場合があることを承諾するものとします。
            </li>
            <li>
              3.
              ID保有者は、対象サービスにおけるアカウントの登録・利用等に関し、対象サービスが定める各規約に従うものとします。
            </li>
            <li>4. ID保有者は、対象サービスにおけるアカウント及びパスワードの登録・管理等の責任を負うものとします。</li>
            <li>
              5.
              ID保有者の対象サービスにおけるアカウント及びパスワードの管理、利用または第三者の使用などの理由により、ID保有者または第三者に損害が生じたとしても、当社に債務不履行又は不法行為がない限りその責任はID保有者が負うものとし、当社は責任を負いません。また、登録ユーザーは当社が損害を被ったときは、その被った損害を補償する責任を負います。
            </li>
            <li>
              6.
              対象サービスの利用に関し、ID保有者は、自己の責任において対象サービスを利用するものとし、対象サービスを利用したことにより生じた損害及びトラブル等について当社に債務不履行又は不法行為がない限り当社は責任を負いません。
            </li>
          </ul>
        </Clause>
        <Clause title="第4条（ID保有者による解除）">
          ID保有者は、当社が定める手続きにより本サービス契約の解除ができます。なお、解除後の提携法人のサービス利用条件は提携法人の定める利用規約等に従います。
        </Clause>
        <Clause title="第5条（当社による解除）">
          当社は、ID保有者が次のいずれかに該当する場合には当該利用者の本サービス契約を解除することができるものとします。
          <ul>
            <li>（1）本規約に定める禁止行為を行った場合</li>
            <li>（2）利用条件に合致しない場合</li>
            <li>（3）本規約に違反した場合</li>
            <li>（4）その他、解除が適当であると当社が判断する場合</li>
          </ul>
        </Clause>
        <Clause title="第6条（当社におけるID保有者情報の取り扱い）">
          <ul>
            <li>
              1.当社は、ID保有者情報を当社の「
              <a href="https://dwango.co.jp/terms/privacy/" target="_blank" rel="noopener noreferrer">
                個人情報保護基本方針
              </a>
              」、本条及び次条に記載するところにより、それぞれに定めるとおり取り扱うものとします。
            </li>
            <li>
              2.当社は、ID保有者が対象サービスの利用を停止しまたは対象サービス独自の会員制度から退会等（理由は問いません）したとしても、ID保有者が自ら別途当社が定める手続きに従いZEN
              IDを抹消しない限り、利用する必要がある限りでID保有者の個人情報を保有し利用し続けることができるものとし、ID保有者は、これを予め同意するものとします。
            </li>
          </ul>
        </Clause>
        <Clause title="第7条（当社から提携法人に共同利用するID保有者情報について）">
          当社及び本条第3号に記載の提携法人は、以下に定めるとおり、ID保有者情報（ID保有者の保証人の情報を含みます。）を共同利用します。
          <ul>
            <li>（1）共同して利用される項目は、以下に掲げるID保有者情報とします。</li>
            <li>①当社が保有する情報</li>
            <ul>
              <li>
                i)ZEN
                IDを通じて取得する情報（メールアドレス、認証情報（パスワードもしくはパスキー）、多要素認証の手段（電話番号、等）、ZEN
                IDのユーザーID、等）
              </li>
              <li>
                ii)当社サービスを通じて取得する情報（アクセスログ、PC操作記録、映像・音声・顔写真、顔認証結果、等）
              </li>
            </ul>
            <li>
              ②提携法人のうち共同利用先が保有する情報（メールアドレス、出願番号、所属校あるいは学部、学籍番号、生徒あるいは学生の種別、在籍状況、所属期（入学時期）、学年、卒業予定時期、試験の採点結果、等）
            </li>
            <li>（2）ID保有者情報は、以下に掲げる利用目的のために共同利用するものとします。</li>
            <ul>
              <li>・提携法人による本サービス提供等のため</li>
              <li>・提携法人による本サービス提供等への問い合わせ対応のため</li>
              <li>
                ・提携法人による本サービス提供等に係る連絡や、当該事業の後継事業の引き継ぎに関する業務を実施するため
              </li>
            </ul>
            <li>
              （3）本サービスに関して取り扱う個人情報の共同利用の範囲は、当社及び
              <a href="https://help.zenid.jp/hc/ja/articles/39067050020377" target="_blank" rel="noopener noreferrer">
                こちらのページ
              </a>
              に記載した対象サービスを提供するために必要な提携法人とします。なお、当社は個人情報の保護に関する法律第28条に従い、外国にある第三者への提供を行う場合には、ID保有者の同意を得るものとします。
            </li>
            <li>
              （4）共同利用の管理について責任を有する者の名称等は株式会社ドワンゴとします。株式会社ドワンゴの所在地・代表者は
              <a href="https://dwango.co.jp/company/" target="_blank" rel="noopener noreferrer">
                こちら
              </a>
              をご覧ください。
            </li>
          </ul>
        </Clause>
        <Clause title="第8条（禁止事項）">
          ID保有者は、本サービスの利用に際し次の行為を行ってはならないものとします。
          <ul>
            <li>(1) 本規約に違反する行為</li>
            <li>(2) 法令に違反する行為、犯罪行為及びそれらを教唆又は幇助する行為</li>
            <li>(3) 自己又は第三者の個人情報を公開する行為</li>
            <li>
              (4)
              当社又は第三者の知的財産権、肖像権、プライバシーの権利、名誉、その他の権利又は利益を侵害する行為若しくは侵害するおそれのある行為
            </li>
            <li>(5) 自己のものではないアカウントを利用する行為</li>
            <li>(6) 自己のアカウントを第三者に有償無償を問わず譲渡する行為</li>
            <li>(7) 第三者へ対する誹謗中傷行為</li>
            <li>(8) 故意に本サービスのサーバー又はネットワークへ著しく負荷をかける行為</li>
            <li>(9) 本サービスとは関係のない団体、サービス又は活動に対しての勧誘行為</li>
            <li>(10) 本サービスの運営を妨げる行為</li>
            <li>(11) 反社会的勢力等への利益供与</li>
            <li>(12) 本サービスにおいて、法令または公序良俗に反する行為</li>
            <li>(13) 前各号の行為を直接若しくは間接に惹起し、又は容易にする行為</li>
            <li>(14) その他、本サービス提供会社が不適切と判断する行為</li>
          </ul>
        </Clause>
        <Clause title="第9条（反社会的勢力の排除）">
          ID保有者は、反社会的勢力（暴力団、暴力団員、暴力団員でなくなった時から5年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋等、社会運動等標ぼうゴロまたは特殊知能暴力集団等、その他これらに準ずる者をいいます。）に該当しないこと、また暴力的行為、詐術・脅迫行為、業務妨害行為等違法行為を行わないことを、将来にわたっても表明するものとします。かかる表明に違反した場合には、異議なく本サービスおよび対象サービスの利用停止・終了、ZEN
          IDの抹消、パスワードの削除ならびにID保有者資格の剥奪、損害賠償請求等の対応（法的措置を含みますが、これに限りません）を受け入れるものとします。
        </Clause>
        <Clause title="第10条（損害賠償）">
          <ul>
            <li>
              1.
              ID保有者は、本サービスの利用に関し、自己の責めに帰すべき事由により当社又はその他の第三者に対して損害を与えた場合、これを賠償する責任を負うものとします。
            </li>
            <li>
              2.
              ID保有者は、本サービスの利用に関し、他の利用者又はその他の第三者から、クレームや請求を受け、又は紛争が生じた場合は、当社に債務不履行又は不法行為がない限り、自己の責任と費用負担でこれを解決するものとします。
            </li>
          </ul>
        </Clause>
        <Clause title="第11条（免責）">
          <ul>
            <li>
              1.
              当社は、当社に債務不履行又は不法行為がある場合を除き、当社による本サービスの提供の廃止、停止、利用不能又は変更等、ID保有者が本サービスを利用したこと、又は利用できなかったことによりID保有者に生じた損害について、一切責任を負わないものとします。
            </li>
            <li>
              2.
              当社は、当社に故意又は重過失による場合又はID保有者の生命若しくは身体の侵害が生じた場合を除き、債務不履行又は不法行為により、本サービスに関連してID保有者に損害が生じた場合、逸失利益その他の特別の事情によって生じた損害を賠償する責任を負わず、直接かつ現実に生じた通常生ずべき損害の範囲内でのみ、損害賠償責任を負うものとします。
            </li>
            <li>
              3.
              ID保有者が利用する通信の状態や環境によっては、本サービスが正常にご利用いただけない場合がありますので、あらかじめご了承願います。当社の責めに帰さない通信障害やID保有者のネットワーク状況により本サービスをご利用できない場合、当社はその責任を負わないものとします。
            </li>
          </ul>
        </Clause>
        <Clause title="第12条（準拠法・裁判管轄）">
          <ul>
            <li>1. 本サービスの利用並びに本規約の適用及び解釈は、日本法に準拠するものとします。</li>
            <li>
              2.
              ID保有者は、当社との間で本サービス又は本規約についての紛争については、東京地方裁判所又は東京簡易裁判所を第一審の専属的合意管轄裁判所とすることに合意するものとします。
            </li>
          </ul>
        </Clause>
        <Clause title="第13条（本規約の内容の変更）">
          <ul>
            <li>
              1.
              本規約の内容は、ID保有者への通知なしに変更されることがあります。その場合、当社は変更後の内容及び変更の効力発生日を当社のウェブサイト等に事前に掲載するものとし、ID保有者はこれを確認するものとします。
            </li>
            <li>
              2.
              前項の変更の後は、変更後の本規約に従い、当社は本サービスを提供するものとし、ID保有者はこれに従うものとします。
            </li>
          </ul>
        </Clause>
      </TermsCard>
    </TermsLayout>
  );
}
